import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function IwuaAllView({ onClose, open, prodd }) {
  const navigate = useNavigate();
console.log("prodd",prodd)
  const items1 = [
    {
      key: "5",
      label: "Name",
      children: prodd?.instName ?? "N/A",
    },
    {
      key: "1",
      label: "ID Number",
      children: prodd?.instContIdNumber ?? "N/A",
    },
    {
      key: "2",
      label: "Email",
      children: prodd?.instContEmail ?? "N/A",
    },

    {
      key: "4",
      label: "Phone",
      children: prodd?.instContPhone ?? "N/A",
    },
  ];
  const items2 = [
    {
      key: "1",
      label: "Location",
      children: prodd?.instLocation ?? "N/A",
    }, 
    {
      key: "3",
      label: "Blocks",
      children: prodd?.instBlocks ?? "N/A",
    },
    {
      key: "2",
      label: "Major Crops",
      children: prodd?.instCrops ?? "N/A",
    },
  ];
  const items3 = [
    {
      key: "1",
      label: "Name",
      children: prodd?.instName ?? "N/A",
    }, 
    {
      key: "3",
      label: "Number of Member",
      children: prodd?.instNoOfMembers ?? "N/A",
    },
    
    {
      key: "5",
      label: "Registartion Date",
      children: (
        <div>
          {prodd?.instRegCertDate
            ? moment(prodd?.instRegCertDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "7",
      label: "License",
      children: prodd?.instLicense ?? "N/A",
    },
  ];
  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Iwua Infomation</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title="Iwua Details"
          column={1}
          colon={false}
          items={items3}
          layout="vertical"
        />
        <Descriptions
          title="Details"
          column={1}
          colon={false}
          items={items2}
          layout="vertical"
        />
        <Descriptions
          title="Contact Person"
          column={1}
          colon={false}
          items={items1}
          layout="vertical"
        />
      </div>
    </Drawer>
  );
}

export default IwuaAllView;
